import { useState, useEffect, useRef } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import FileUpload from "../file-upload/file-upload.component";
import "./layout.css";
import gif1 from "../../../assets/gif1.gif";
import gif2 from "../../../assets/gif2.gif";
import gif3 from "../../../assets/gif3.gif";
import React from "react";
import _ from "lodash";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import LocalStorageLayout from "../test";
import httpService from "../../../services/http.service";
import DropboxChooser from "react-dropbox-chooser";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImages,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import bgImage from "../../../assets/image.jpg";
import "react-toastify/dist/ReactToastify.css";
import ReactAudioPlayer from "react-audio-player";
import 'react-h5-audio-player/lib/styles.css';
import Loader from "../../common/loader";
import useDrivePicker from 'react-google-drive-picker'
import SuccessMessage from "../../common/successMsg";
import WarningMessage from "../../common/warnMsg";
import ErrorMessage from "../../common/errorMsg";
import ThumbnailSlider from "./ThumbnailSlider";
import NasPop from "../NasSelectModalWindow/nasPop";
import SoundPermission from "./soundPermission";

let intervalWeather = setInterval(() => { }, 30000);
let Layout = (props) => {
  const history = useHistory();
  const NasUser = localStorage.getItem('customerId')
  let BucketUser = localStorage.getItem('UserId')
  const containerRef = useRef(null);
  const [openPicker, authResponse] = useDrivePicker();
  const [BgPicture, setBgPicture] = useState(bgImage);
  const [dropdownWidget, setdropdownWidget] = useState(false);
  const [addwidgettype, setaddwidgettype] = useState("");
  const [modalPicture, setmodalPicture] = useState(false);
  const [modalSlideShare, setmodalSlideShare] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDocxUpload, setModalDocxUpload] = useState(false);
  const [modalOptionsDocxUpload, setModalOptionsDocxUpload] = useState(false);
  const [modalOptionsName, setModalOptionsName] = useState("");


  const [slideshraeWebLink, setslideshraeWebLink] = useState("");
  const [modalcongrats, setmodalcongrats] = useState(false);
  const [congratgif, setcongratgif] = useState("false");
  const [Congratulation, setCongratulation] = useState("");
  const [listarray, setlistarray] = useState([]);
  const [Slidesarray, setSlidesarray] = useState([]);
  const [listcontent, setlistcontent] = useState("");
  const [listcontentStatrt, setlistcontentStart] = useState("");
  const [listcontentStartDate, setlistcontentStartDate] = useState("");
  const [listcontentEndDate, setlistcontentEndDate] = useState("");
  const [listcontentEnd, setlistcontentEnd] = useState("");
  const [modallist, setmodallist] = useState(false);
  const [audioTitle, setaudioTitle] = useState("");
  const [slideTitle, setSlideTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [slideabout, setslideabout] = useState("");
  const [slidetime, setslidetime] = useState(3);
  const [weatherInput, setweatherInput] = useState("");
  const [weatherWind, setweatherWind] = useState("mi");
  const [weatherTemp, setweatherTemp] = useState("F");

  const [modalwebIframe, setmodalwebIframe] = useState(false);
  const [modalweather, setmodalweather] = useState(false);
  const [modalaudio, setmodalaudio] = useState(false);
  const [modalyoutubevideo, setmodalyoutubevideo] = useState(false);
  const [modalvideoPlayer, setmodalvideoPlayer] = useState(false);
  const [modalannouncement, setmodalannouncement] = useState(false);
  // const [modalOneDrive, setmodalOneDrive] = useState(false);
  const [modalBgPicture, setmodalBgPicture] = useState(false);
  const [weblinkframe, setweblinkframe] = useState("");
  const [youtubeVideo, setyoutubevideo] = useState("");
  const [videoPlayer, setvideoPlayer] = useState("");
  const [announcementtext, setannouncementtext] = useState("");
  const [driveClientid, setdriveClientid] = useState("");
  const [drivekey, setdrivekey] = useState("");
  const [dropboxkey, setdropboxkey] = useState("");
  const [weatherApiKey, setweatherApiKey] = useState("");
  const [layout, setlayout] = useState([]);
  const [audioArray, setaudioArray] = useState([]);
  const [audioArrayfetched, setaudioArrayfetched] = useState([]);
  const [audioIndex, setaudioIndex] = useState(0);
  const [widgetAudioArray, setwidgetAudioArray] = useState([]);
  const [selectedAudioId, setselectedAudioId] = useState("Background Music");
  const [volume, setVolume] = useState(0.5);
  const [muted, setMuted] = useState(false);
  const finalVolume = muted ? 0 : volume ** 2;

  const toggle = () => setdropdownWidget((prevState) => !prevState);
  const togglePicture = () => setmodalPicture((prevState) => !prevState);
  const toggleSlideShare = () => setmodalSlideShare((prevState) => !prevState);
  const togglecongrats = () => setmodalcongrats((prevState) => !prevState);
  const toggleDocxUpload = () => setModalDocxUpload((prevState) => !prevState);
  const toggleOptionsDocxUpload = () => setModalOptionsDocxUpload((prevState) => !prevState);

  const togglelist = () => setmodallist((prevState) => !prevState);
  const togglewebIframe = () => setmodalwebIframe((prevState) => !prevState);
  const toggleweather = () => setmodalweather((prevState) => !prevState);
  const toggleaudio = () => setmodalaudio((prevState) => !prevState);
  const toggleBgPicture = () => setmodalBgPicture((prevState) => !prevState);
  const toggleyoutubewidget = () =>
    setmodalyoutubevideo((prevState) => !prevState);
  const toggleVideoPlayer = () =>
    setmodalvideoPlayer((prevState) => !prevState);
  const toggleannouncement = () =>
    setmodalannouncement((prevState) => !prevState);
  // const toggleOneDrive = () => setmodalOneDrive((prevState) => !prevState);

  const [layoutError, setlayoutError] = useState(false);
  const [widgetList, setwidgetList] = useState([]);
  const [widgetLoading, setwidgetLoading] = useState(false);
  const [widthLayout, setwidthLayout] = useState(0);
  const [deleteWidgetId, setdeleteWidgetId] = useState([]);
  const [editWidgeContent, seteditWidgeContent] = useState([]);
  const [refreshTime, setRefreshTime] = useState(props.refreshTime);

  // convertapi 
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [docxUpload, setDocxUpload] = useState();
  const [imageUrls, setImageUrls] = useState([]);
  const [previewName, setPreviewName] = useState("");

  const [showFileUploadDialog, setShowFileUploadDialog] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  // nas
  const [files, setFiles] = useState([])
  const [showPicker, setShowPicker] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [whichNasSelection, setWhichNasSelection] = useState("")
  const [nas_space, setNas_space] = useState(0)
  const [nasLicenceDate, setNasLicenceDate] = useState(false)
  const [naslicence, setNaslicence] = useState(false)

  function isCurrentDateBetween(startDate, endDate) {
    const currentDate = new Date(); // Get the current date

    // Convert input dates to Date objects if they aren't already
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Check if the current date is between or equal to the start and end dates
    if (currentDate >= start && currentDate <= end) {

      return true;
    } else {


      return false;
    }
  }

  async function getUsersNASInfo() {
    try {
      const res = await httpService.get(`/check-gcp-storage?userId=${BucketUser}`);
      console.log(res.data, "USER_NAS_DETAIL");
      if (res.data) {
        setNas_space(res.data.user.nasSpace);
        setNasLicenceDate(isCurrentDateBetween(res.data.user.startDateNas, res.data.user.endDateNas))
        if (res.data.user.nasSpace > 0) {
          if (isCurrentDateBetween(res.data.user.startDateNas, res.data.user.endDateNas)) {
            setNaslicence(false)
          } else {
            setNaslicence(true)

          }
        } else {
          setNaslicence(true)

        }
      }
    } catch (err) {
      console.log({ err });
    }
  }
  useEffect(() => {
    getUsersNASInfo();
  }, [])



  const handleSelectFile = (fileName) => {
    console.log("Filename : ", fileName)
    setSelectedFiles((prevSelected) => ({
      ...prevSelected,
      [fileName]: !prevSelected[fileName],
    }));
  };

  const handleDeselectAll = () => {
    setSelectedFiles({});
  };

  const createSliderUsingNAS = async (selected) => {

    const requestBody = {
      imageUrls: selected,
      layoutId: props.selectedLayoutID,
    };
    try {
      let result = await httpService.CreateUpdate("createSliderWidget", requestBody)
      if (result.data.ack === "1") {
        SuccessMessage('Slider widget created successfully')
        setShowFileUploadDialog(false);
        setmodalSlideShare(false);
        setModalDocxUpload(false)
        handleDeselectAll()
      } else {
        console.error('Error creating slider widget');
      }
      loadData();
    } catch (error) {
      console.error('Error making API request:', error);
    }
  };

  const handleNASSubmit = () => {
    const selected = Object.keys(selectedFiles).filter(
      (fileName) => selectedFiles[fileName]
    );
    console.log('Selected files:', selected);

    if (whichNasSelection === "background") {
      handleSubmitBgPicture(selected[0], "backgroundimage")
    } else if (whichNasSelection === "audio") {
      selected.map((file, index) => {
        let name = file?.split("/")
        let len = name?.length

        let array = [...audioArray];


        array.push({ link: `${window.location.origin}/api/v1/gcp-asset-file?userId=${BucketUser}&filePath=${file}`, name: name[len - 1] });
        setaudioArray(array);

      })

    } else if (whichNasSelection === "picture") {
      // selected.map((file,index)=>{
      let name = selected[0]?.split("/")
      let len = name?.length
      handleSubmitPicture(selected[0], name[len - 1])

    } else {
      createSliderUsingNAS(selected)

    }
    setShowPicker(false);
    setWhichNasSelection("")
    setSelectedFiles({})
  };

  useEffect(() => {
    if (files.length > 0) {
      setShowPicker(true);
    } else {
      setShowPicker(false);
    }
  }, [files]);

  useEffect(() => {
    setRefreshTime(props.refreshTime)
  }, [props.refreshTime])

  useEffect(() => {
    if (!props.verifyTokenUser && history.location.pathname != '/login') history.push('/login')
  }, [props.verifyTokenUser])

  const getRefreshTime = (time) => {
    intervalWeather = setInterval(() => {
      httpService.get('getRefreshTime')
        .then((res) => {
          if (res.data.data != time)
            setRefreshTime(res.data.data)
        }).catch((e) => null)
      loadData();
    }, Number(time ? time : 5) * 60 * 1000);
  }

  // convert api -

  const handleUploadClick = async () => {
    showLoader();

    try {
      if (!docxUpload) {
        console.error('No DOCX file uploaded.');
        return;
      }
      let formData = {
        file: docxUpload,
        user: localStorage.getItem("Username"),
        layout_id: props.selectedLayoutID,
        opfor: modalOptionsName,
        username: NasUser,
      };
      console.log(formData, "convertDocToImg")

      let user = await httpService.uploadBackup("convertDocToImg", formData);
      console.log(user, "convertDocToImg")
      if (user.data.ack == 1) {
        setShowFileUpload(false);
        hideLoader();
        SuccessMessage('Docx file converted to PNG and saved to Dropbox.')
        const urls = user.data?.imageUrls || [];
        setImageUrls(urls);
        setPreviewName(user.data.name)

      }
      else ErrorMessage(user.data.message)
    } catch (err) {
      console.log(err, "convertDocToImg")

      console.error('Error in handleUploadClick:', err);
      ErrorMessage(JSON.stringify(err.message))
      hideLoader();
    }
  };

  const updateFilesCb = (files) => {
    //debugger
    setDocxUpload(files[0]);
  };
  useEffect(() => {
    if (imageUrls.length > 0) {
      setShowFileUpload(false);
    }
  }, [imageUrls]);

  const handleSelectFromLocal = (e) => {
    setModalOptionsName(e)

    setPreviewName("")
    setModalDocxUpload(true);
    setSelectedImages([]);
    setImageUrls([])
  };

  const handleSelectForStorag = () => {

    setModalOptionsDocxUpload(true);
    setSelectedImages([]);
    setImageUrls([])
  };

  const handleCreateSlider = async (selectedImages) => {
    try {
      const requestBody = {
        imageUrls: selectedImages,
        layoutId: props.selectedLayoutID,
      };

      const result = await httpService.CreateUpdate("createSliderWidget", requestBody);
      hideLoader()
      loadData();
      setSelectedImages([]);
      setImageUrls([])
      if (result.data.ack === "1") {
        SuccessMessage('Slider widget created successfully')
        setShowFileUploadDialog(false);
        setmodalSlideShare(false);
        setModalDocxUpload(false)
      } else {
        console.error('Error creating slider widget');
      }

    } catch (error) {
      console.error('Error making API request:', error);
    }
  };

  useEffect(() => {
    if (props.preview) {
      getRefreshTime(refreshTime)
      return () => clearInterval(intervalWeather);
    }
  }, [refreshTime]);

  useEffect(() => {
    if (containerRef && containerRef.current && containerRef.current.offsetWidth && !loading) {
      setwidthLayout(parseInt(containerRef.current.offsetWidth));
    }
  }, [
    modalPicture,
    listarray,
    Slidesarray,
    widgetList,
    widgetLoading,
    layoutError,
    containerRef,
    widthLayout,
    BgPicture,
  ]);

  useEffect(() => {
    if (containerRef && containerRef.current && containerRef.current.offsetWidth && !loading) {
      setwidthLayout(parseInt(containerRef.current.offsetWidth));
    }
  });

  // useEffect(() => {
  // }, [bgImage, audioIndex, audioArrayfetched])

  useEffect(async () => {
    loadData();
  }, []);

  const handleSelectFromNASMedia = () => {
    setModalOpen(true);
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const loadData = async () => {
    if (props.selectedLayoutID.length > 0) {
      showLoader();
      let dataPost = {
        layout_id: props.selectedLayoutID,
      };
      let SelecetdLayoutdata = await httpService
        .CreateUpdate("getSelectedLayoutData", dataPost)
        .catch((err) => {
          if (err && err.response && err.response.status == 401 && localStorage.getItem("UserId")) {
            ErrorMessage("Session expired, please login again")
          }
          return;
        });
      setaudioArrayfetched(
        SelecetdLayoutdata?.data?.data[0]?.audio
          ? SelecetdLayoutdata?.data?.data[0]?.audio
          : []
      );
      setselectedAudioId(SelecetdLayoutdata?.data?.data[0]?.audioId ? SelecetdLayoutdata?.data?.data[0]?.audioId : "Background Music");
      setVolume(
        SelecetdLayoutdata?.data?.data[0]?.audioSet
          ? SelecetdLayoutdata?.data?.data[0]?.audioSet[0]
          : 0.5
      );
      setMuted(
        SelecetdLayoutdata?.data?.data[0]?.audioSet
          ? SelecetdLayoutdata?.data?.data[0]?.audioSet[1]
          : false
      );

      let widgetdata = await httpService
        .CreateUpdate("getwidgetsApi", dataPost)
        .catch((err) => {
          return;
        });
      let BgImagedata = await httpService
        .CreateUpdate("getbgpictureApi", dataPost)
        .catch((err) => {
          return;
        });
      let Locationdata = await httpService
        .CreateUpdate("getwidgetlocationAPI", dataPost)
        .catch((err) => {
          return;
        });
      let clientIddata = await httpService
        .CreateUpdate("getClientIdData")
        .catch((err) => {
          return;
        });
      if (clientIddata?.data[0]) {
        setdriveClientid(clientIddata?.data[0]?.GoogleDriveClientId);
        setdrivekey(clientIddata?.data[0]?.GoogleDriveKey);
        setdropboxkey(clientIddata?.data[0]?.DropboxKey);
        setweatherApiKey(clientIddata?.data[0]?.weatherApiKey);
      }
      setBgPicture(BgImagedata?.data?.data);
      setlayout(Locationdata?.data?.data);
      setwidgetList(widgetdata?.data?.data);
      let audioArray = [];
      let obj = {
        value: `${"Background Music"}`,
        label: `${"Background Music"}`,
        id: `Background Music`,
        data: "Background Music",
      };
      audioArray.push(obj)
      for (let i = 0; i < widgetdata?.data?.data?.length; i++) {
        if (widgetdata.data.data[i].type === "youtube" || widgetdata.data.data[i].type === "videoplayer" || widgetdata.data.data[i].type === "initialvideoplayer") {
          let obj = {
            value: `${widgetdata.data.data[i]._id}`,
            label: `${widgetdata.data.data[i].type} (${widgetdata.data.data[i].content[0]})`,
            id: `${widgetdata.data.data[i]._id}`,
            data: widgetdata.data.data[i],
          };
          audioArray.push(obj);
        }
      }
      setwidgetAudioArray(audioArray);
      setwidgetLoading(true);
      hideLoader();
    }
  }

  useEffect(async () => {
    // showLoader();
    var currentUrl = window.location.href;
    let accessToken = currentUrl.substring(
      currentUrl.indexOf("=") + 1,
      currentUrl.indexOf("&")
    );
    // hideLoader();
  }, []);

  useEffect(() => {
    // showLoader();
    if (widgetLoading && !loading) {
      const ratio =
        (parseInt(containerRef.current.offsetWidth && !loading) * 100.0) /
        parseInt(containerRef.current.clientHeight && !loading);
      const defaultratio = (16 * 100.0) / 9;
      if (ratio > defaultratio) {
        setlayoutError(true);
      } else {
        setlayoutError(false);
      }
    }
    // hideLoader();
  });

  const playnext = (index) => {
    console.log("Audio Index:", index, audioArrayfetched.length);

    if (audioArrayfetched.length === 1) {
      // Only one audio, replay the same
      console.log("Hello World")
      setaudioIndex(0);
    } else if (index === audioArrayfetched.length - 1) {
      // End of the array, go to first
      setaudioIndex(0);
    } else {
      // Move to next audio
      setaudioIndex(index + 1);
    }
  };
  const handleOpenPicker = () => {
    openPicker({
      clientId: driveClientid,
      developerKey: drivekey,
      viewId: "DOCS",
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      viewMimeTypes: 'image/jpeg,image/png',
      // viewMimeTypes: ['image/jpeg', 'image/png'],

      // customViews: customViewsArray, // custom view
      callbackFunction: (data) => {
        if (data.docs) {
          data.docs.map((i) => {
            setaddwidgettype("picture");
            handleSubmitPicture(i.url, i.name);
          });
        }
      },
    })
  }
  const handleOpenPicker2 = () => {
    openPicker({
      clientId: driveClientid,
      developerKey: drivekey,
      viewId: "DOCS",
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      viewMimeTypes: 'audio/mp3,audio/mpeg',
      // viewMimeTypes: ["audio/mpeg", "audio/mp3"],
      // customViews: customViewsArray, // custom view
      callbackFunction: (data) => {
        if (data.docs) {
          data.docs.map((i) => {
            setaddwidgettype("audioplayer");
            // handl`eSubmitPicture(i.url, i.name);
            let array = [...audioArray];
            array.push({ link: i.url, name: i.name });
            setaudioArray(array);
          });
        }
      },
    })
  }
  const handleOpenPicker3 = () => {
    openPicker({
      clientId: driveClientid,
      developerKey: drivekey,
      viewId: "DOCS",
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      viewMimeTypes: 'image/jpeg,image/png',
      // viewMimeTypes: ['image/jpeg', 'image/png'],
      // customViews: customViewsArray, // custom view
      callbackFunction: (data) => {
        if (data.docs) {
          data.docs.map((i) => {
            handleSubmitBgPicture(i.url, i.name);
          });
        }
      },
    })
  }

  const getNasFile = async (data) => {
    let res = await httpService.get(`/show-user-bucket-files?userID=${BucketUser}`)
      .then((res) => res.data)
      .catch((err) => {
        ErrorMessage(err.response.data);
        return null;
      });

    // console.log("Res get :", res)
    if (data.format === "audio") {
      const allAudioFiles = res?.files.filter((item) => {
        console.log("Item : ", item)
        const fileSplit = item.name.split(".")[1].toLowerCase();
        return data.type.includes(fileSplit);
      });
      if (allAudioFiles.length === 0) {
        WarningMessage("There is no audio file. Please upload it first.");
        return
      }
      setFiles(allAudioFiles);
    }

    if (data.format === "image") {
      const allImageFiles = res?.files.filter((item) => {
        const fileSplit = item.name.split(".")[1].toLowerCase();
        return data.type.includes(fileSplit);
      });
      if (allImageFiles.length === 0) {
        WarningMessage("There is no image file. Please upload it first.");
        return
      }
      setFiles(allImageFiles);
    }
  };

  const handleOpenPicker4 = () => {
    const data = {
      type: ["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"],
      format: "image",
    };
    getNasFile(data);
    toggleSlideShare()
  }

  const handleOpenPicker4BackgroundImage = () => {
    const data = {
      type: ["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"],
      format: "image",
    };
    getNasFile(data);
    setWhichNasSelection("background")
    // toggleSlideShare()
  }

  const handleOpenPicker4BackgroungAudio = () => {
    const data = {
      type: ["mp3", "aac", "ogg", "wma", "amr", "mp2"],
      format: "audio",
    };
    getNasFile(data);
    setWhichNasSelection("audio")
    // toggleSlideShare()
  }

  const handleOpenPicker4Picture = () => {
    const data = {
      type: ["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"],
      format: "image",
    };
    getNasFile(data);
    setWhichNasSelection("picture")
    // toggleSlideShare()
  }

  const refreshWeatherData = () => {
    if (widgetList.length > 0) {
      widgetList.map(async (e, index) => {
        if (e.type === "weather") {
          let response = await fetch(
            `https://api.openweathermap.org/data/2.5/weather?q=${e.content[0].name}&appid=${weatherApiKey}`
          ).then(async (response) => {
            if (response.status === 404) {
              WarningMessage("Something Went Wrong")
              return;
            } else {
              const dataRec = await response.json();
              let data = {
                type: "weather",
                id: e._id,
                content: [dataRec],
              };
              let widgetdata = await httpService
                .CreateUpdate("updateWidgetApi", data)
                .catch((err) => {
                  return;
                });
              if (widgetdata.ack === "1") {
                let std = [...widgetList];
                std[index].content = [dataRec];
                setwidgetList(std);
              }
            }
          });
        }
      });
    }
  };
  const fetchData = async () => {
    // intervalWeather = setInterval(()=>{
    //   refreshWeatherData();
    // },30000)
  };
  useEffect(() => {
    // showLoader();
    fetchData();
    return () => {
      clearInterval(intervalWeather);
    };
    // hideLoader();
  }, []);

  const getWidgets = async () => {
    let dataPost = {
      layout_id: props.selectedLayoutID,
    };
    let widgetdata = await httpService
      .CreateUpdate("getwidgetsApi", dataPost)
      .catch((err) => {
        return;
      });
    setwidgetList(widgetdata.data.data);
    setwidgetLoading(true);
  };

  const getAudioId = (e) => {
    console.log("Audio Files : ", e)
    if (e != "") {
      if (e.includes("drive.google")) {
        let field = e.split("file/d/");
        let stringdata = field[1].split("/view")[0];
        if (window.location.origin.substring(0, 5) === "http:") {
          // return "https://docs.google.com/uc?export=open&id=" + stringdata;
          return "https://drive.google.com/thumbnail?id=" + stringdata;
          // return "https://docs.google.com/uc?export=download&id=" + "1XPTnQHfU0WGaJJ-ZxJSXvRPYr_2Y4UBj";
        } else {
          // return "https://docs.google.com/uc?export=open&id=" + stringdata;
          return "https://drive.google.com/thumbnail?id=" + stringdata;

          // return "https://docs.google.com/uc?export=download&id=" + "1XPTnQHfU0WGaJJ-ZxJSXvRPYr_2Y4UBj";
        }
      } else if (e.includes("dropbox.com")) {
        let urlreturn = e.replace("dl=0", "dl=1");
        return urlreturn;
      } else if (!(e.includes("dropbox.com"))) {
        let urlreturn = e;
        return urlreturn;
      }

    } else {
      return ""
    }
  };
  const handleSubmitAudio = async () => {
    // if (audioArray.length <= 0) {
    //   toast.warn("Please select some audio file", {
    //     position: "bottom-left",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //   });
    //   return;
    // }
    const data = {
      content: audioArray,
      layout_id: props.selectedLayoutID,
      volume: volume,
      muted: muted,
      selectedAudioId: selectedAudioId
    };

    console.log(data, "data q")
    let user = await httpService
      .CreateUpdate("addaudioLayout", data)
      .catch((err) => {
        ErrorMessage("Unable to update playlist")
      });

    setmodalaudio(false);
    setaudioArrayfetched(audioArray);
    setaudioArray([]);
    SuccessMessage("Audio playlist updated successfully")
  };

  const isValidStreamURL = (url) => {
  try {
    const parsed = new URL(url);

    const isHttp = ["http:", "https:"].includes(parsed.protocol);
    const isStream = /\.(m3u8|mpd)(\?.*)?$/.test(parsed.pathname);

    return isHttp && isStream;
  } catch {
    return false;
  }
};

  const handleSubmit = async () => {
    // event.preventDefault();
    let user = {};
    if (addwidgettype === "list") {
      if (listarray.length === 0) {
        WarningMessage("Please add something to the list")
        return;
      }
      var sortedArray = listarray.sort(function (a, b) {
        return a[5] - b[5];
      });
      setlistarray(sortedArray);
      const data = {
        type: "list",
        content: listarray,
        layout_id: props.selectedLayoutID,
      };
      user = await httpService.CreateUpdate("addwidgetApi", data).catch((err) => {
        return;
      });

      setmodallist(false);
      setlistarray([]);
      SuccessMessage("List Widget Added ")
    } else if (addwidgettype === "youtube") {
      if (youtubeVideo === "") {
        WarningMessage("Please Enter the youTube URL")
        return;
      }

      {
        var p =
          /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        if (youtubeVideo.match(p)) {
        } else {
          WarningMessage("Please Enter the Valid YouTube URL")
          return;
        }
      }

      // }
      const data = {
        type: "youtube",
        content: [youtubeVideo],
        layout_id: props.selectedLayoutID,
      };
      user = await httpService
        .CreateUpdate("addwidgetApi", data)
        .catch((err) => {
          ErrorMessage("Unable to add Widget");
        });

      setmodalyoutubevideo(false);
      setyoutubevideo("");
      SuccessMessage("Youtube Widget Added ")
    } else if (addwidgettype === "videoplayer") {
      if (videoPlayer === "") {
        WarningMessage("Please Enter the URL")
        return;
      }

      const isValid = isValidStreamURL(videoPlayer)

      if(!isValid){
        SuccessMessage("Invalid stream URL. Please provide a valid HLS (.m3u8) or DASH (.mpd) stream.")
        return
      }

      const data = {
        type: "videoplayer",
        content: [videoPlayer],
        layout_id: props.selectedLayoutID,
      };
      user = await httpService
        .CreateUpdate("addwidgetApi", data)
        .catch((err) => {
          ErrorMessage("Unable to add Widget")
        });

      setmodalvideoPlayer(false);
      setvideoPlayer("");
      SuccessMessage("Video Player Widget Added ")
      // } else if (addwidgettype == "audioplayer") {
      //   if (audioArray.length <= 0) {
      //     toast.warn("Please select some audio file", {
      //       position: "bottom-left",
      //       autoClose: 5000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //       progress: undefined,
      //     });
      //     return;
      //   }
      //   const data = {
      //     type: "audioplayer",
      //     content: audioArray,
      //     layout_id: props.selectedLayoutID,
      //   };
      //    user = await httpService
      //     .CreateUpdate("addwidgetApi", data)
      //     .catch((err) => {
      //       console.log(err);
      //       toast.error("Unable to add Widget", {
      //         position: "bottom-left",
      //         autoClose: 5000,
      //         hideProgressBar: false,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: true,
      //         progress: undefined,
      //       });
      //     });

      //   setmodalaudio(false);
      //   setaudioArray([]);
      //   toast.success("Audio Player Widget Added ", {
      //     position: "bottom-left",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //   });
    } else if (addwidgettype === "webiframe") {
      if (weblinkframe === "") {
        WarningMessage("Please Enter the Website URL")
        return;
      }

      const data = {
        type: "webiframe",
        content: [weblinkframe],
        layout_id: props.selectedLayoutID,
      };
      user = await httpService
        .CreateUpdate("addwidgetApi", data)
        .catch((err) => {
          return;
        });

      setmodalwebIframe(false);
      setweblinkframe("");
      SuccessMessage("WebIframe Widget Added ")
    } else if (addwidgettype === "announcement") {
      if (announcementtext === "") {
        WarningMessage("Please Enter the Announcement")
        return;
      }
      const data = {
        type: "announcement",
        content: [announcementtext],
        layout_id: props.selectedLayoutID,
      };
      user = await httpService
        .CreateUpdate("addwidgetApi", data)
        .catch((err) => {
          return;
        });

      setmodalannouncement(false);
      setannouncementtext("");
      SuccessMessage("Announcement Widget Added ")
    } else if (addwidgettype === "weather") {
      if (weatherInput === "") {
        WarningMessage("Please Enter the city name");
        return;
      }
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?zip=${weatherInput},us&appid=${weatherApiKey}`
      ).then(async (response) => {
        if (response.status === 401) {
          WarningMessage("Something Went Wrong")
          return;
        }
        if (response.status === 404) {
          WarningMessage("Please Enter the city code correctly.")
          return;
        } else {
          const data = await response.json();
          const dataPost = {
            type: "weather",
            content: [data, weatherInput, weatherWind, weatherTemp],
            layout_id: props.selectedLayoutID,
          };
          user = await httpService
            .CreateUpdate("addwidgetApi", dataPost)
            .catch((err) => {
              return;
            });
          setweatherInput("");
          setmodalweather(false);
          SuccessMessage("Weather Widget Added")
        }
      });
      // getWidgets();
    } else if (addwidgettype === "congrats") {
      if (Congratulation === "") {
        WarningMessage("Please Enter the Congratulation message")
        return;
      }
      if (congratgif === "") {
        WarningMessage("Please select the congratulation GIF")
        return;
      }
      const data = {
        type: "congrats",
        content: [Congratulation, congratgif],
        layout_id: props.selectedLayoutID,
      };
      user = await httpService
        .CreateUpdate("addwidgetApi", data)
        .catch((err) => {
          return;
        });
      setmodalcongrats(false);
      setCongratulation("");
      setcongratgif("");
      SuccessMessage("Congratulation Widget Added ")
    } else if (addwidgettype === "slideshare") {
      if (Slidesarray.length === 0) {
        WarningMessage("Please add some slides")
        return;
      }
      const data = {
        type: "slideshare",
        content: Slidesarray,
        layout_id: props.selectedLayoutID,
      };
      user = await httpService
        .CreateUpdate("addwidgetApi", data)
        .catch((err) => {
          return;
        });
      SuccessMessage("Slideshare Widget Added ")
      setmodalSlideShare(false);
      setslideshraeWebLink("");
      setSlideTitle("");
      setslideabout("");
      setslidetime(3);
      setSlidesarray([]);
    }
    let addwidgetDeleteData = props.addwidgetDelete;
    addwidgetDeleteData.push(user.data.id);
    props.setaddwidgetDelete(addwidgetDeleteData);
    // getWidgets();
    let widgetdata = [...widgetList];
    widgetdata.push(user.data.data);
    setwidgetList(widgetdata);
  };

  const handleSubmitPicture = async (url, name) => {
    let user = {};
    if (url === "") {
      WarningMessage("Image not selected")
      return;
    }
    const data = {
      type: "picture",
      content: [
        {
          title: name,
          image: url,
        },
      ],
      layout_id: props.selectedLayoutID,
    };

    user = await httpService.CreateUpdate("addwidgetApi", data).catch((err) => {
      return;
    });
    SuccessMessage("Picture Widget Added ")
    let addwidgetDeleteData = props.addwidgetDelete;
    addwidgetDeleteData.push(user.data.id);
    props.setaddwidgetDelete(addwidgetDeleteData);
    setmodalPicture(false);
    // getWidgets();
    let widgetdata = [...widgetList];
    widgetdata.push(user.data.data);
    setwidgetList(widgetdata);
  };
  const handleSubmitBgPicture = async (url, name) => {
    console.log(url, "Selected files:")
    if (url === "") {
      WarningMessage("Image not selected")
      return;
    }
    const data = {
      content: url,
      layout_id: props.selectedLayoutID,
    };

    const user = await httpService
      .CreateUpdate("savebgpictureApi", data)
      .catch((err) => {
        return;
      });
    SuccessMessage("Background Picture Changed ")
    setmodalPicture(false);
    setmodalBgPicture(false);

    // toggleBgPicture

    setBgPicture(url);
  };

  const onSubmit = (e) => {
    e.preventDefault();
  };

  const saveLayout = async () => {
    showLoader();
    let layoutArray = layout;
    // for (let i = 0; i < layout.length; i++) {
    //   if (layout[i].y >= 18) {
    //     let data = {
    //       id: layout[i].i,
    //     };
    //     await httpService.CreateUpdate("removewidgetApi", data).catch((err) => {
    //       return;
    //     });
    //     layoutArray.splice(i, 1);
    //   }
    // }
    for (let i = 0; i < deleteWidgetId.length; i++) {
      let dataDelete = {
        id: deleteWidgetId[i],
      };
      await httpService
        .CreateUpdate("removewidgetApi", dataDelete)
        .catch((err) => { return; });
    }
    setdeleteWidgetId([]);

    for (let i = 0; i < editWidgeContent.length; i++) {
      let dataedit = editWidgeContent[i];
      let widgetdata = await httpService
        .CreateUpdate("updateWidgetApi", dataedit)
        .catch((err) => {
          return;
        });
    }
    seteditWidgeContent([]);

    setlayout(layoutArray);
    let data = {
      location: layout,
      layout_id: props.selectedLayoutID,
    };
    await httpService
      .CreateUpdate("savewidgetlocationAPI", data)
      .catch((err) => {
        return;
      });
    SuccessMessage("Layout Saved ")
    if (global.localStorage) {
      global.localStorage.setItem(
        "rgl-7",
        JSON.stringify({
          ["layout"]: layout,
        })
      );
    }
    props.setaddwidgetDelete([]);
    getWidgets();
    hideLoader();
  };

  const addtolist = () => {
    if (listcontent === "") {
      WarningMessage("Please enter some Content to add in the list")
      return;
    } else if (listcontentStatrt === "") {
      WarningMessage("Please enter start time to add in the list")
      return;
    } else if (listcontentEnd === "") {
      WarningMessage("Please enter End Time to add in the list")
      return;
    } else if (listcontentStartDate === "") {
      WarningMessage("Please enter Start Date to add in the list")
      return;
    } else if (listcontentEndDate === "") {
      WarningMessage("Please enter End Date to add in the list")
      return;
    }
    if (listcontent != "") {
      let stYr = listcontentStartDate.substring(0, 4);
      let stmon = parseInt(listcontentStartDate.substring(5, 7)) - 1;
      let stday = listcontentStartDate.substring(8, 10);
      let enYr = listcontentEndDate.substring(0, 4);
      let enmon = parseInt(listcontentEndDate.substring(5, 7)) - 1;
      let enday = listcontentEndDate.substring(8, 10);

      let sthr = listcontentStatrt.substring(0, 2);
      let stmin = listcontentStatrt.substring(3, 5);
      let enhr = listcontentEnd.substring(0, 2);
      let enmin = listcontentEnd.substring(3, 5);

      let startDate = new Date(stYr, stmon, stday, sthr, stmin).getTime();
      let endDate = new Date(enYr, enmon, enday, enhr, enmin).getTime();

      let diff = endDate - startDate;

      if (diff > 0) {
        let array = [...listarray];
        array.push([listcontent, listcontentStatrt, listcontentEnd, listcontentStartDate, listcontentEndDate, startDate, endDate]);
        setlistarray(array);
        setlistcontent("");
        setlistcontentStart("");
        setlistcontentEnd("");
        setlistcontentStartDate("");
        setlistcontentEndDate("");
        SuccessMessage("Added to the list")
      } else {
        WarningMessage("Please enter End Date greater than the start date")
      }
    }
  };
  const AddtoSlides = async () => {
    // let baseImage = "";
    // const getBase64 = (file) => {
    //   return new Promise((resolve) => {
    //     let fileInfo;
    //     let baseURL = "";
    //     let reader = new FileReader();

    //     reader.readAsDataURL(file);

    //     reader.onload = () => {
    //       console.log("Called", reader);
    //       baseURL = reader.result;
    //       console.log(baseURL);
    //       resolve(baseURL);
    //     };
    //     console.log(fileInfo);
    //   });
    // };
    // if (slideTitle === "") {
    //   WarningMessage("Please enter the slide title")
    //   return;
    // }
    // if (slideabout === "") {
    //   WarningMessage("Please enter something about the slide")
    //   return;
    // }
    if (slidetime === 0) {
      WarningMessage("Please enter the time for the slide")
      return;
    }
    if (slideshraeWebLink === "") {
      WarningMessage("Please enter the url or select the picture")
      return;
    }
    {
      var p =
        /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      if (slideshraeWebLink.match(p)) {
      } else {
        WarningMessage("Please Enter the Valid YouTube URL")
        return;
      }
    }
    let array = [...Slidesarray];
    if (slideshraeWebLink != "") {
      if (slideshraeWebLink != "") {
        array.push([
          slideshraeWebLink,
          "weblink",
          slideTitle,
          slideabout,
          slidetime,
        ]);
      }
      SuccessMessage("Slide added to the slideshare")
      // if (slideSharepicture.Images.length != 0) {
      //   array.push([
      //     baseImage,
      //     "image",
      //     slideSharepicture.Images[0].name,
      //     slideTitle,
      //     slideabout,
      //     slidetime,
      //   ]);
      // }
    }
    setSlidesarray(array);
    setslideshraeWebLink("");
    setSlideTitle("");
    setslideabout("");
    setslidetime(3);
  };
  const handleSubmitPictureSlideshare = async (url, name) => {
    let array = [...Slidesarray];
    array.push([url, "image", name, slideTitle, slideabout, slidetime]);
    setSlidesarray(array);
    setslideshraeWebLink("");
    setSlideTitle("");
    setslideabout("");
    setslidetime(3);
  };
  const removelistcontent = (i) => {
    let array = [...listarray];
    array.splice(i, 1);
    setlistarray(array);
  };
  const removeslidearraycontent = (i) => {
    let array = [...Slidesarray];
    array.splice(i, 1);
    setSlidesarray(array);
  };

  // const oneDriveFilePicker = () => {
  //   toggleOneDrive();
  // };
  const getAuthenticationToken = () => {
    return Promise.resolve(
      "EwCYA8l6BAAUwihrrCrmQ4wuIJX5mbj7rQla6TUAAbtqHdRksO36h6sKq+oqEaMinsfZuefV3kkfpKgLnUc3Drnhy8ogTqxinG8nE7kSZZamS+EVGfEr0hx1tfBv1C4Qyex5PAA6sIv63eZCRtcC76mMCccP6vzTWZmDISOtOZjcw5eJJfvwH3yDP97rjwJWnonhkmCqGaGrObeqHf1uz5H6hkGGTwS2u4QwDSFopceaVs8QSA6kXhFvt9ciYFCDEwkxRUolXEkm2+X7hwq13cX9UzYzg7BUErsfce9Amb6w92qLGYgnGu6jQqZK+jLZvNkzaa7eHf8jw43p9QfBC8W6BODS1D0FKLcugJ37MWYG6wYETFll0A4sGMv2hywDZgAACK1UtgDjzFsWaAJyNkl9juKLktKmmqPKry3+mY9QYG+2z3am6b7uDS1kqqrEFtFWFFkYyF7xvmGoRrDGnWMuH6OU995UClA/Bl6IkUZOB72N8HqNsry7fZv5aXjehJ+n325XMc09YcQRltowxQkt7nG5Bg7Zn/NW5PVZi2YECFeSW8IRvMn18qcjnZ0LOV+xOUCbaDD4kTVovowK02E7W2YoSsT6ataZt/Ds1C3lDEqNoTDrZ8Th7fe0mP6VcszQPz371Asnu1ZKEPvUKW89XOp/ieg0USIh9qUaBAM00XEfjAiR+KfktxZVP1nGFyJJljywcwC9TaeV++0r5MTHAeidkGAdITihm9kU/sVfiwOP/KXnXnsE0urgbN9t66CspFVe5SmAHicvuEf2TVW74LUDmc90OcriHfgMJplrXRWJl/bOhvozU/ZLLr9M3qCLV9A13EcDOWzfpwT5gYPopzfeekaFKfo3bdmsmlvT2T4nOuW5EO3Ixo5VOQL5eiDATWZ6fUhGzTXPFG+Q383ORPLhR0vMvNNIL6OSw30EK/bilE25osgPGgAJE0oE1ZJ+xbMgpm5Y0z4admK6GZ6b4EhMzVuxeVEcW+Z2lU5mEsSH/E/u1nc1bcnoe1xOGV7SA8tS5uYxsbQ9FV4+ZrkPRNoLuwp+8rzRKDXqkUjSn2EhnmXjCEijZ6/UAb9pFPmZntgamWpL0USDuswagzQyfonCDs4wbyqbA47IfCe+TTZ4WurKOtyIPPfTPKdgSUDrr4hCaTZ4iVp5P2o1vFkC4BWnwtHjxZdbOlTh6W+NxjNm/cV84fRIR3xzuCAQyM2N0Ga3rwI="
    );
  };

  const onSuccess = (keys) => {
    console.log("onSuccess", keys);
  };
  const getpictureurl = (url) => {
    // alert(url)
    let finalUrl = "";
    let urlreturn = "";
    if (url?.includes("drive.google")) {
      finalUrl = url.substring(
        url?.indexOf("/file/d/") + 8,
        url?.indexOf("/view")
      );
      urlreturn = "https://drive.google.com/thumbnail?id=" + finalUrl;
      // urlreturn = "https://drive.google.com/uc?export=view&id=" + finalUrl;
      console.log(" : " + urlreturn)
    } else if (url?.includes("dropbox.com")) {
      urlreturn = url?.replace("dl=0", "raw=1");
    } else if (!(url?.includes("dropbox.com"))) {
      // urlreturn = url?.replace("dl=0", "raw=1");

      urlreturn = `${window.location.origin}/api/v1/gcp-asset-file?userId=${BucketUser}&filePath=${url}`;

      if (window.location.href.includes('/view/')) {
        urlreturn = `${window.location.origin}/api/v1/gcp-asset-file?filePath=${url}&billbordid=${window.location.href.split("/view/")[1].split("/")[0]}`;
      }
    }
    return urlreturn;
  };
  const showLoader = () => {
    setLoading(true);
  }
  const hideLoader = () => {
    setLoading(false);

  }

  // const [browserModal, setBrowserModal] = useState(false)

  // function getBrowserName() {
  //   const userAgent = navigator.userAgent;

  //   if (userAgent.includes("Chrome") && !userAgent.includes("Edg") && !userAgent.includes("OPR")) {
  //     return "Chrome";
  //   } else if (userAgent.includes("Firefox")) {
  //     return "Firefox";
  //   } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
  //     return "Safari";
  //   } else if (userAgent.includes("Edg")) {
  //     return "Edge";
  //   } else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
  //     return "Opera";
  //   } else {
  //     return "Unknown";
  //   }
  // }

  // const checkPermissions = async () => {
  //   const permissionsToCheck = [
  //     'geolocation',
  //     'notifications',
  //     'audio',
  //     'camera',
  //     'microphone',
  //     'persistent-storage',
  //     'clipboard-read',
  //     'clipboard-write'
  //   ];

  //   for (const name of permissionsToCheck) {
  //     try {
  //       const result = await navigator.permissions.query({ name });
  //       console.log(`${name}: ${result.state}`); // granted | denied | prompt

  //       // Optional: Listen for changes
  //       result.onchange = () => {
  //         console.log(`${name} changed to ${result.state}`);
  //       };
  //     } catch (err) {
  //       console.warn(`Permission ${name} is not supported`, err);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   checkPermissions();
  //   const browser = getBrowserName()

  //   if (browser === "Chrome") {
  //     if (props.preview) {
  //       setBrowserModal(true)
  //     }
  //   }
  //   console.log("Your Browser name is : ", browser)
  //   console.log("props.preview : ", props.preview)
  // }, [])

  const maxRows = 48
  const margin = 4
  const [rowHeight, setRowHeight] = useState();
  const calculateRowHeight = () => {
    const container = containerRef.current;
    if (container) {
      const availableHeight = container.clientHeight - (margin * maxRows);

      const newHeight = (availableHeight / maxRows);
      console.log(1388, availableHeight, newHeight)
      setRowHeight(newHeight); // minimum height
    }

  };
  useEffect(() => {
    calculateRowHeight();
    window.addEventListener("resize", calculateRowHeight);
    return () => window.removeEventListener("resize", calculateRowHeight);
  }, [containerRef.current]);

  return (
    <div className="mainlayout row">
      {loading ? <Loader /> : null}
      <span className="headerLayout col-9" hidden={props.preview}>
        <Dropdown
          className="backup-dropdown addwidgetmain"
          isOpen={dropdownWidget}
          toggle={toggle}
        >
          <DropdownToggle className="btn btn-primary mt-1 addwidgetButton">
            <b>+ Add Widget</b>
          </DropdownToggle>
          <DropdownMenu style={{ left: "0px !important" }}>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#Modal"
              onClick={() => {
                setaddwidgettype("slideshare");
                setmodalSlideShare(true);
              }}
            >
              Slideshare
            </DropdownItem>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#pictureModal"
              onClick={() => {
                setaddwidgettype("picture");
                setmodalPicture(true);
              }}
            >
              Picture
            </DropdownItem>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={() => {
                setaddwidgettype("congrats");
                setmodalcongrats(true);
              }}
            >
              Congratulation
            </DropdownItem>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={() => {
                setaddwidgettype("list");
                setmodallist(true);
              }}
            >
              List
            </DropdownItem>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={() => {
                setaddwidgettype("webiframe");
                setmodalwebIframe(true);
              }}
            >
              Web Iframe
            </DropdownItem>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={() => {
                setaddwidgettype("announcement");
                setmodalannouncement(true);
              }}
            >
              Announcement
            </DropdownItem>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={() => {
                setaddwidgettype("youtube");
                setmodalyoutubevideo(true);
              }}
            >
              YouTube Video
            </DropdownItem>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={() => {
                setaddwidgettype("videoplayer");
                setmodalvideoPlayer(true);
              }}
            >
              DASH/HLS Video Player
            </DropdownItem>
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={() => {
                setaddwidgettype("weather");
                setmodalweather(true);
              }}
            >
              Weather
            </DropdownItem>
            {/*<DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={() => {
                setaddwidgettype("audioplayer");
                setmodalaudio(true);
              }}
            >
              Audio Player
            </DropdownItem>*/}
            <DropdownItem
              center
              data-toggle="modal"
              data-target="#weeklyModal"
              onClick={async () => {
                setaddwidgettype("date");
                const data = {
                  type: "date",
                  content: ["Date/Time", "-4", true, true],
                  timeFormat: "12h",
                  layout_id: props.selectedLayoutID,
                };
                const user = await httpService
                  .CreateUpdate("addwidgetApi", data)
                  .catch((err) => {
                    return;
                  });

                let addwidgetDeleteData = props.addwidgetDelete;
                addwidgetDeleteData.push(user.data.id);
                props.setaddwidgetDelete(addwidgetDeleteData);
                let widgetdata = [...widgetList];
                widgetdata.push(user.data.data);
                setwidgetList(widgetdata);
                // getWidgets();
              }}
            >
              Date/Time
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>{" "}
        <Button
          color="primary"
          type="submit"
          className="backgroundbutton"
          onClick={() => {
            toggleBgPicture();
          }}
        >
          {BgPicture?.length > 0 ? "Update" : "Set"} Background Image
        </Button>
        <Button
          color="primary"
          type="submit"
          className="backgroundbutton"
          style={{ marginLeft: "4px" }}
          onClick={() => {
            toggleaudio();
            setaudioArray(audioArrayfetched);
          }}
        >
          Background Music
        </Button>
      </span>
      {/*
      <div className="col-4 errormessage" hidden={props.preview}>
        <div hidden={layoutError}></div>
</div>*/}
      <div className="col-3 headerLayoutgoback" hidden={props.preview}>
        {widgetLoading && widgetList?.length != 0 && (
          <Button
            color="primary"
            type="submit"
            className="form-control savelayoutbutton"
            onClick={() => {
              if (
                window.confirm(
                  "Saving Layout will delete all the widgets outside the defined boundary. Do you want to proceed?"
                ) == true
              ) {
                saveLayout();
              }
            }}
          // disabled={!layoutError}
          >
            <FontAwesomeIcon className="iconSaveLayout" icon={faSave} /> Save
            Layout
          </Button>
        )}
      </div>

      {widgetLoading && (
        <div ref={containerRef} className="layoutRef">
          <img
            src={BgPicture?.length ? getpictureurl(BgPicture) : bgImage}
            className="bgImage"
            alt="BgImage"
            hidden={!BgPicture?.length && props.view}
          />
          <LocalStorageLayout
            widgetList={widgetList}
            setlayout={setlayout}
            layout={layout}
            setwidgetList={setwidgetList}
            borderColor={props.borderColor}
            borderWidth={props.borderWidth}
            widthLayout={widthLayout}
            setrightContentType={props.setrightContentType}
            rightContentType={props.rightContentType}
            getWidgets={getWidgets}
            preview={props.preview}
            selectedLayoutID={props.selectedLayoutID}
            setselectedLayoutID={props.setselectedLayoutID}
            toggleeditLayout={props.toggleeditLayout}
            deleteWidgetId={deleteWidgetId}
            setdeleteWidgetId={setdeleteWidgetId}
            editWidgeContent={editWidgeContent}
            seteditWidgeContent={seteditWidgeContent}
            volume={volume}
            muted={muted}
            selectedAudioId={selectedAudioId}
            driveClientid={driveClientid}
            drivekey={drivekey}
            dropboxkey={dropboxkey}
            weatherApiKey={weatherApiKey}
            openPicker={openPicker}
            authResponse={authResponse}
            naslicence={naslicence}
            rowHeight={rowHeight}
            maxRows={maxRows}
            margin={[margin, margin]}
          ></LocalStorageLayout>
        </div>
      )}
      <div className="marginLayout" hidden={props.preview}>
        {""}
      </div>
      {/* <SoundPermission isOpen={browserModal} setBrowserModal={setBrowserModal} /> */}
      <Modal
        isOpen={modalPicture}
        toggle={togglePicture}
        className="modaleditLayout"
      >
        <ModalHeader toggle={togglePicture}>Upload Picture</ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit}>
              {/*<FileUpload
                accept=".jpg,.png,.jpeg"
                label=""
                updateFilesCb={updateUploadedFiles}
              />*/}
              <div className="row">
                <div className="col-6 selectButton">
                  <DropboxChooser
                    appKey={dropboxkey}
                    success={async (files) => {
                      setmodalPicture(false);
                      await files.map((i) => {
                        handleSubmitPicture(i.link, i.name);
                      });
                    }}
                    cancel={() => console.log("closed")}
                    multiselect={true}
                  >
                    <Button className="form-control" color="primary">
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from dropbox</div>
                      </div>
                    </Button>
                  </DropboxChooser>
                </div>
                <div className="col-6 selectButton">
                  <Button
                    disabled={naslicence}
                    title="Hello World!"
                    className="form-control"
                    color="primary"
                    onClick={() => { handleOpenPicker4Picture() }}
                  >
                    <div className="row">
                      <div className="col-9">Cloud Storage</div>
                    </div>
                  </Button>
                  {/*<GooglePicker
                    className="googlepickerbox"
                    clientId={driveClientid}
                    developerKey={drivekey}
                    scope={["https://www.googleapis.com/auth/drive.readonly"]}
                    onChange={async (data) => {
                      if (data.docs) {
                        console.log("on change:", data.docs);
                        data.docs.map((i) => {
                          setaddwidgettype("picture");
                          handleSubmitPicture(i.url, i.name);
                        });
                        if (data.docs.length > 0) {
                          // props.toggleeditLayout();
                        }
                      }
                    }}
                    onAuthFailed={(data) =>
                      console.log("on auth failed:", data)
                    }
                    multiselect={false}
                    navHidden={true}
                    authImmediate={false}
                    mimeTypes={["image/png", "image/jpeg", "image/jpg"]}
                    // query={'a query string like .txt or fileName'}
                    viewId={"DOCS"}
                  >
                    <Button
                      className="form-control"
                      color="primary"
                      onClick={() => {
                        setmodalPicture(false);
                        // props.toggleeditLayout();
                      }}
                    >
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from Drive</div>
                      </div>
                    </Button>
                    </GooglePicker>*/}
                  {/* <Button
                    className="form-control"
                    color="primary"
                    onClick={() => {
                      setmodalPicture(false);
                      handleOpenPicker();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from Drive</div>
                    </div>
                  </Button> */}
                </div>
                <div className="col-3 selectButton"></div>
                {/*<div className="col-6 selectButton">
                  <Button
                    color="primary"
                    className="form-control"
                    onClick={() => {
                      setmodalPicture(false);
                      oneDriveFilePicker();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from OneDrive</div>
                    </div>
                  </Button>
                  </div>*/}
              </div>
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modalaudio}
        toggle={toggleaudio}
        className="modaleditLayout"
      >
        <ModalHeader toggle={toggleaudio}>Audio Settings</ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit}>
              {/*<b>Enter the Title of Audio </b>
              <b style={{ color: "red" }}>*</b>
              <input
                type="text"
                className="form-control slideshowTitle"
                value={audioTitle}
                onChange={(e) => setaudioTitle(e.target.value)}
              ></input>*/}
              <div className="row">
                <div className="col-9 selectButton">
                  <b style={{ paddingTop: "30px" }}>Select Audio Type </b>
                  <section>
                    <Select
                      options={widgetAudioArray}
                      placeholder="Choose Rule"
                      // defaultInputValue={selectedAudioId}
                      defaultValue={{ label: selectedAudioId, value: selectedAudioId }}
                      onChange={(event) => {
                        setselectedAudioId(event.value);
                      }}
                    />
                  </section>
                </div>
                <div className="col-3 selectButton" style={{ paddingTop: "27px", paddingRight: "10px" }}>
                  <Button
                    className="form-control"
                    onClick={() => setMuted((m) => !m)}
                    style={{ marginLeft: "5px" }}
                  >
                    {muted ? "muted" : "unmuted"}
                  </Button>
                </div>

              </div>
              <div style={{ margin: "10px 5px", padding: "5px", border: "1px solid gray" }} className="row">
                <b>Choose Audio </b>
                <div className="col-6 selectButton">
                  <DropboxChooser
                    appKey={dropboxkey}
                    success={async (files) => {
                      console.log("chose:", files);
                      // setmodalPicture(false);
                      await files.map((i) => {
                        // handleSubmitPicture(i.link, i.name);
                        let array = [...audioArray];
                        array.push({ link: i.link, name: i.name });
                        setaudioArray(array);
                      });
                    }}
                    cancel={() => console.log("closed")}
                    multiselect={false}
                  >
                    <Button className="form-control" color="primary">
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from dropbox</div>
                      </div>
                    </Button>
                  </DropboxChooser>
                </div>
                <div className="col-6 selectButton">
                  <Button
                    disabled={naslicence}

                    className="form-control"
                    color="primary"
                    onClick={() => { handleOpenPicker4BackgroungAudio() }}
                  >
                    <div className="row">
                      <div className="col-9">Cloud Storage</div>
                    </div>
                  </Button>
                  {/*<GooglePicker
                    className="googlepickerbox"
                    clientId={driveClientid}
                    developerKey={drivekey}
                    scope={["https://www.googleapis.com/auth/drive.readonly"]}
                    onChange={async (data) => {
                      if (data.docs) {
                        console.log("on change:", data.docs);
                        data.docs.map((i) => {
                          setaddwidgettype("audioplayer");
                          // handl`eSubmitPicture(i.url, i.name);
                          let array = [...audioArray];
                          array.push({ link: i.url, name: i.name });
                          setaudioArray(array);
                        });
                        if (data.docs.length > 0) {
                          // props.toggleeditLayout();
                        }
                      }
                    }}
                    onAuthFailed={(data) =>
                      console.log("on auth failed:", data)
                    }
                    onAuthenticate = {(token) =>{
                      console.log(token);
                    }}
                    multiselect={true}
                    navHidden={true}
                    authImmediate={false}
                    mimeTypes={["audio/mpeg", "audio/mp3"]}
                    // query={'a query string like .txt or fileName'}
                    viewId={"DOCS"}
                  >
                    <Button
                      className="form-control"
                      color="primary"
                      onClick={() => {
                        setmodalPicture(false);
                        // props.toggleeditLayout();
                      }}
                    >
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from Drive</div>
                      </div>
                    </Button>
                    </GooglePicker>*/}
                  {/* <Button
                    className="form-control"
                    color="primary"
                    onClick={() => {
                      setmodalPicture(false);
                      handleOpenPicker2();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from Drive</div>
                    </div>
                  </Button> */}
                </div>
                <div className="col-3 selectButton"></div>

                {/*<div className="col-6 selectButton">
                  <Button
                    color="primary"
                    className="form-control"
                    onClick={() => {
                      setmodalPicture(false);
                      oneDriveFilePicker();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from OneDrive</div>
                    </div>
                  </Button>
                  </div>*/}
                <div style={{ marginTop: "15px", borderTop: "1px solid gray" }}>
                  <div className="row" style={{ borderBottom: "1px dashed gray" }}>
                    <div className="col-6" style={{ fontSize: "large", fontWeight: "bold" }}>Playlist</div>
                    <div className="col-6 selectButton">
                      <b style={{ paddingTop: "0px", display: "inline-block" }}>Set Volume </b>
                      <section style={{ display: "inline-block", paddingLeft: "10px", paddingTop: "0px" }}>
                        <input
                          type="range"
                          min={0}
                          max={1}
                          step={0.02}
                          value={volume}
                          onChange={(event) => {
                            setVolume(event.target.valueAsNumber);
                          }}
                        />
                      </section>
                    </div>
                  </div>
                  {audioArray.map((elem, index) => {
                    return (
                      <div className="row">
                        <div className="col-10" style={{ paddingTop: "6px" }}>
                          {elem.name}
                        </div>
                        <div className="col-2">
                          <Button
                            color="Secondary"
                            className="col-1"
                            onClick={() => {
                              let array = [...audioArray];
                              array.splice(index, 1);
                              setaudioArray(array);
                            }}
                          >
                            x
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={handleSubmitAudio}
              >
                Save
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>

      {selectedAudioId === "Background Music" || selectedAudioId == "" ? <ReactAudioPlayer
        style={{ display: "none" }}
        className="playallaudioplayer"
        loop={audioArrayfetched.length === 1}
        src={
          audioArrayfetched[audioIndex]
            ? getAudioId(
              audioArrayfetched[audioIndex].link
                ? audioArrayfetched[audioIndex].link
                : ""
            )
            : ""
        }
        volume={volume}
        muted={muted}
        controls
        autoPlay={true}
        key={audioIndex}
        onEnded={() => audioArrayfetched.length > 1 && playnext(audioIndex)}
      /> : ""}
      {/*{selectedAudioId == "Background Music" || selectedAudioId == "" ? <AudioPlayer
      autoPlay = {true}
      style={{ display: "none" }}
      className="playallaudioplayer"
      src={
        audioArrayfetched[audioIndex]
          ? getAudioId(
              audioArrayfetched[audioIndex].link
                ? audioArrayfetched[audioIndex].link
                : ""
            )
          : ""
      }
      volume={volume}
      muted={muted}
      onEnded={() => playnext(audioIndex)}
    />: ""}*/}
      <Modal isOpen={modalBgPicture} toggle={toggleBgPicture}>
        <ModalHeader toggle={toggleBgPicture}>
          Upload Background Picture
        </ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit}>
              {/*<FileUpload
                accept=".jpg,.png,.jpeg"
                label=""
                updateFilesCb={updateUploadedFiles}
              />*/}
              <div className="row">
                <div className="col-6 selectButton">
                  <DropboxChooser
                    appKey={dropboxkey}
                    success={async (files) => {
                      setmodalBgPicture(false);
                      await files.map((i) => {
                        handleSubmitBgPicture(i.link, i.name);
                      });
                    }}
                    cancel={() => console.log("closed")}
                    multiselect={false}
                  >
                    <Button className="form-control" color="primary">
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from dropbox</div>
                      </div>
                    </Button>
                  </DropboxChooser>
                </div>
                <div className="col-6 selectButton">
                  <Button
                    disabled={naslicence}
                    className="form-control"
                    color="primary"
                    onClick={() => { handleOpenPicker4BackgroundImage() }}
                  >
                    <div className="row">
                      <div className="col-9">Cloud Storage</div>
                    </div>
                  </Button>
                </div>
                <div className="col-4 selectButton">
                  {/* <Button
                    color="primary"
                    type="button"
                    className="form-control mb-2"
                  >
                    <a
                      href={`${window.location.origin}/api/v1/dropbox?userid=${props.selectedLayoutID}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "white" }}
                      onClick={handleSelectFromLocal}
                    >
                      Local
                    </a>
                  </Button> */}
                </div>
                <div className="col-6 selectButton">

                  {/*<GooglePicker
                    clientId={driveClientid}
                    developerKey={drivekey}
                    scope={["https://www.googleapis.com/auth/drive.readonly"]}
                    onChange={async (data) => {
                      if (data.docs) {
                        console.log("on change:", data.docs);
                        data.docs.map((i) => {
                          handleSubmitBgPicture(i.url, i.name);
                        });
                        if (data.docs.length > 0) {
                          // props.toggleeditLayout();
                        }
                      }
                    }}
                    onAuthFailed={(data) =>
                      console.log("on auth failed:", data)
                    }
                    multiselect={false}
                    navHidden={true}
                    authImmediate={false}
                    mimeTypes={["image/png", "image/jpeg", "image/jpg"]}
                    // query={'a query string like .txt or fileName'}
                    viewId={"DOCS"}
                  >
                    <Button
                      className="form-control"
                      color="primary"
                      onClick={() => {
                        setmodalBgPicture(false);
                        // props.toggleeditLayout();
                      }}
                    >
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from Drive</div>
                      </div>
                    </Button>
                    </GooglePicker>*/}
                  {/* <Button
                    className="form-control"
                    color="primary"
                    onClick={() => {
                      setmodalBgPicture(false);
                      handleOpenPicker3();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from Drive</div>
                    </div>
                  </Button> */}
                </div>
                <div className="col-3 selectButton"></div>
                {/*<div className="col-6 selectButton">
                  <Button
                    color="primary"
                    className="form-control"
                    onClick={() => {
                      // setmodalBgPicture(false);
                      oneDriveFilePicker();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from OneDrive</div>
                    </div>
                  </Button>
                  </div>*/}
              </div>
            </form>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalSlideShare} toggle={toggleSlideShare}>
        <ModalHeader toggle={toggleSlideShare}>
          Create a new Slideshare
        </ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit} className="slidesharemainform">
              {/* <b>Enter the Title of Slide </b>
              <b style={{ color: "red" }}>*</b>
              <input
                type="text"
                className="form-control slideshowTitle"
                value={slideTitle}
                onChange={(e) => setSlideTitle(e.target.value)}
              ></input>
              <b>Enter something about the Slide </b>
              <b style={{ color: "red" }}>*</b>
              <input
                type="text"
                className="form-control slideshowTitle"
                value={slideabout}
                onChange={(e) => setslideabout(e.target.value)}
              ></input> */}
              <b>Enter Timeframe of the Slide (in sec) </b>
              <b style={{ color: "red" }}>*</b>
              <input
                type="number"
                className="form-control slideshowTitle"
                value={slidetime}
                onChange={(e) => setslidetime(e.target.value)}
              ></input>
              <b>Select the Picture to upload</b>
              <div className="row">
                <div className="col-4 selectButton">
                  <DropboxChooser
                    appKey={dropboxkey}
                    success={async (files) => {
                      await files.map((i) => {
                        handleSubmitPictureSlideshare(i.link, i.name);
                      });
                    }}
                    cancel={() => console.log("closed")}
                    multiselect={true}
                  >
                    <Button className="form-control" color="primary">
                      <div className="row">
                        {/* <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div> */}
                        <div className="col-9">Dropbox</div>
                      </div>
                    </Button>
                  </DropboxChooser>
                </div>

                {/*<GooglePicker
                    clientId={driveClientid}
                    developerKey={drivekey}
                    scope={["https://www.googleapis.com/auth/drive.readonly"]}
                    onChange={async (data) => {
                      if (data.docs) {
                        console.log("on change:", data.docs);
                        data.docs.map((i) => {
                          handleSubmitPictureSlideshare(i.url, i.name);
                        });
                      }
                    }}
                    onAuthFailed={(data) =>
                      console.log("on auth failed:", data)
                    }
                    multiselect={false}
                    navHidden={true}
                    authImmediate={false}
                    mimeTypes={["image/png", "image/jpeg", "image/jpg"]}
                    // query={'a query string like .txt or fileName'}
                    viewId={"DOCS"}
                  >
                    <Button
                      className="form-control"
                      color="primary"
                      onClick={() => {}}
                    >
                      <div className="row">
                        <div className="col-3">
                          <FontAwesomeIcon className="icon" icon={faImages} />
                        </div>
                        <div className="col-9">Select from Drive</div>
                      </div>
                    </Button>
                  </GooglePicker>*/}
                <div className="col-4 selectButton">
                  <Button
                    disabled={naslicence}
                    className="form-control"
                    color="primary"
                    onClick={() => { handleOpenPicker4() }}
                  >
                    <div className="row">
                      <div className="col-9">Cloud Storage</div>
                    </div>
                  </Button>
                </div>
                <div className="col-4 selectButton">
                  <Button
                    color="primary"
                    type="button"
                    className="form-control mb-2"
                    onClick={handleSelectForStorag}
                  >
                    Word Conversion
                  </Button>
                </div>
                {/*<div className="col-6 selectButton">
                  <Button
                    color="primary"
                    className="form-control"
                    onClick={() => {
                      // setmodalPicture(false);
                      oneDriveFilePicker();
                    }}
                  >
                    <div className="row">
                      <div className="col-3">
                        <FontAwesomeIcon className="icon" icon={faImages} />
                      </div>
                      <div className="col-9">Select from OneDrive</div>
                    </div>
                  </Button>
                  </div>*/}
              </div>
              <div className="orcenter"> OR </div>
              <b>Enter the url of youtube video</b>
              <input
                type="url"
                className="form-control websiteLink"
                value={slideshraeWebLink}
                onChange={(e) => setslideshraeWebLink(e.target.value)}
              ></input>
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={AddtoSlides}
              >
                Add to Slideshare
              </Button>{" "}
              {/*<Button color="secondary" onClick={CancelSlideShareClickHandler}>Cancel</Button>*/}
              <div className="slideshareborder"></div>
            </form>
            <div className="availableSlideshares"> Slides to Upload</div>
            {Slidesarray.map((e, i) => (
              <div>
                {e[1] == "weblink" ? (
                  <div className="row slidetoadd">
                    <b className="col-11">
                      {i + 1}. {e[0]}
                    </b>
                    <Button
                      color="Secondary"
                      className="col-1"
                      onClick={() => removeslidearraycontent(i)}
                    >
                      x
                    </Button>
                  </div>
                ) : (
                  <div className="row slidetoadd">
                    <b className="col-11">
                      {i + 1}.{" "}
                      <img
                        width="auto"
                        height="80px"
                        src={getpictureurl(e[0])}
                        alt="image"
                      />
                    </b>
                    <Button
                      color="Secondary"
                      className="col-1"
                      onClick={() => removeslidearraycontent(i)}
                    >
                      x
                    </Button>
                  </div>
                )}
              </div>
            ))}
            <Button
              color="primary"
              type="submit"
              className="form-control"
              onClick={handleSubmit}
            >
              Save
            </Button>{" "}
          </div>
          {loading && <Loader />}
        </ModalBody>

        {/* ----------------------------------------------------------------------- */}
        <Modal isOpen={modalOptionsDocxUpload} toggle={toggleOptionsDocxUpload}>
          <ModalHeader toggle={toggleOptionsDocxUpload}>
            Choose the Storage
          </ModalHeader>
          <ModalBody>
            <div className="uploadFilesDocx">

              <>
                {loading && <Loader />}
                <Button
                  color="primary"
                  type="button"
                  className="form-control btn-mm"
                  onClick={() => {
                    handleSelectFromLocal("dropbox")
                    window.open(`${window.location.origin}/api/v1/dropbox?userid=${props.selectedLayoutID}`, "_blank", "noopener noreferrer");
                  }}
                >

                  Dropbox Word Conversion

                </Button>
                <Button
                  color="primary"
                  type="button"
                  className="form-control btn-mm"
                  onClick={() => handleSelectFromLocal("Nas")}
                >
                  Cloud Storage Word Conversion
                </Button>
              </>

            </div>
          </ModalBody>
        </Modal>
        {/* ---------------------------------------------------------------------------- */}
        <Modal isOpen={modalDocxUpload} toggle={toggleDocxUpload}>
          <ModalHeader toggle={toggleDocxUpload}>
            Upload Local Files:- {previewName}
          </ModalHeader>
          <ModalBody>
            <div className="uploadFilesDocx">
              {imageUrls.length <= 0 ? (
                <>
                  <FileUpload
                    accept=".docx"
                    label="Upload a Docx File"
                    updateFilesCb={updateFilesCb}
                  />
                  {loading && <Loader />}
                  <Button
                    color="primary"
                    type="button"
                    className="form-control btn-mm"
                    onClick={handleUploadClick}
                  >
                    Save
                  </Button>
                </>
              ) : (
                <>
                  <div>
                    <ThumbnailSlider
                      imageUrls={imageUrls}
                      setSelectedImagesp={setSelectedImages}
                    />
                    <p></p>
                  </div>
                  <Button
                    color="primary"
                    type="submit"
                    className="form-control btn-m"
                    onClick={() => handleCreateSlider(selectedImages)}
                    disabled={imageUrls.length === 0}
                  >
                    Create slider
                  </Button>
                </>
              )}
            </div>
          </ModalBody>
        </Modal>
        {/* ------------------------------------------------------------- */}
      </Modal>

      <Modal isOpen={modalcongrats} toggle={togglecongrats}>
        <ModalHeader toggle={togglecongrats}>
          Create a new Congratulation WIdget
        </ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit} className="slidesharemainform">
              <b>Enter the Congratulations Message</b>{" "}
              <b style={{ color: "red" }}>*</b>
              <textarea
                type="test"
                className="form-control websiteLink"
                value={Congratulation}
                onChange={(e) => setCongratulation(e.target.value)}
              ></textarea>
              <div className="slideshareborder"></div>
              <div className="availableSlideshares">
                {" "}
                Choose GIFs <b style={{ color: "red" }}>*</b>
              </div>
              <div className="row">
                <div
                  className="col-4"
                  onClick={() => {
                    setcongratgif("1");
                  }}
                >
                  {congratgif === "1" ? (
                    <img
                      className="congratsgif activegif"
                      src={gif1}
                      alt="gift"
                    ></img>
                  ) : (
                    <img className="congratsgif" src={gif1} alt="gift"></img>
                  )}
                </div>

                <div
                  className="col-4"
                  onClick={() => {
                    setcongratgif("2");
                  }}
                >
                  {congratgif === "2" ? (
                    <img
                      className="congratsgif activegif"
                      src={gif2}
                      alt="gift"
                    ></img>
                  ) : (
                    <img className="congratsgif" src={gif2} alt="gift"></img>
                  )}
                </div>

                <div
                  className="col-4"
                  onClick={() => {
                    setcongratgif("3");
                  }}
                >
                  {congratgif === "3" ? (
                    <img
                      className="congratsgif activegif"
                      src={gif3}
                      alt="gift"
                    ></img>
                  ) : (
                    <img className="congratsgif" src={gif3} alt="gift"></img>
                  )}
                </div>
              </div>
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={handleSubmit}
              >
                Create
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modallist} toggle={togglelist}>
        <ModalHeader toggle={togglelist}>Create a new List WIdget</ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit} className="slidesharemainform">
              <div className="row">
                <label>
                  <b>Item Label</b>
                </label>
                <div className="col-12" style={{ padding: "5px" }}>

                  <input
                    type="text"
                    className="form-control"
                    value={listcontent}
                    onChange={(e) => setlistcontent(e.target.value)}
                  ></input>
                </div>
                <label>
                  <b>Starts At</b>
                </label>
                <div className="col-6" style={{ padding: "5px" }}>

                  <input
                    type="date"
                    format="YYYY-MM-DD"
                    name="ProgramSchedule"
                    className="form-control"
                    value={listcontentStartDate}
                    onChange={(e) => setlistcontentStartDate(e.target.value)}
                  />
                </div>
                <div className="col-6" style={{ padding: "5px" }}>
                  <input
                    type="time"
                    format="HH:mm"
                    name="ProgramSchedule"
                    className="form-control"
                    value={listcontentStatrt}
                    onChange={(e) => setlistcontentStart(e.target.value)}
                  />
                </div>
                <label>
                  <b>Ends At</b>
                </label>
                <div className="col-6" style={{ padding: "5px" }}>

                  <input
                    type="date"
                    format="YYYY-MM-DD"
                    name="ProgramSchedule"
                    className="form-control"
                    value={listcontentEndDate}
                    onChange={(e) => setlistcontentEndDate(e.target.value)}
                  />
                </div>
                <div className="col-6" style={{ padding: "5px", marginBottom: "10px" }}>

                  <input
                    type="time"
                    format="HH:mm"
                    name="ProgramSchedule"
                    className="form-control"
                    value={listcontentEnd}
                    onChange={(e) => setlistcontentEnd(e.target.value)}
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-6">
                  <Button
                    color="info"
                    type="submit"
                    className=" form-control"
                    onClick={() => addtolist()}
                  >
                    Add to List
                  </Button>
                </div>
                <div className="col-3"></div>
              </div>
              <div className="slideshareborder"></div>
              {listarray.map((e, i) => (
                <div className="row" style={{ marginBottom: "4px", paddingBottom: "4px", borderBottom: "0.8px solid gray" }}>
                  <div className="col-11 row">
                    <b className="col-11">{e[0]}</b>

                    <div className="col-6">
                      {e[1]} {"("}{e[3]}{")"}
                    </div>
                    <div className="col-6">
                      {e[2]} {"("}{e[4]}{")"}
                    </div>
                  </div>
                  <Button
                    color="Secondary"
                    className="col-1"
                    onClick={() => removelistcontent(i)}
                  >
                    x
                  </Button>
                </div>
              ))}
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={handleSubmit}
              >
                Create List
              </Button>{" "}
              {/*<Button color="secondary" onClick={CancelSlideShareClickHandler}>Cancel</Button>*/}
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalwebIframe} toggle={togglewebIframe}>
        <ModalHeader toggle={togglewebIframe}>
          Create a new Web Iframe Widget
        </ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit} className="slidesharemainform">
              <b>Enter the url of Website</b>
              <b style={{ color: "red" }}>*</b>
              <input
                type="url"
                className="form-control websiteLink"
                value={weblinkframe}
                onChange={(e) => setweblinkframe(e.target.value)}
              ></input>
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={handleSubmit}
              >
                Create
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalweather} toggle={toggleweather}>
        <ModalHeader toggle={toggleweather}>
          Create a new Weather Widget
        </ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit} className="slidesharemainform">
              <b>Enter the City ZIP code</b>
              <b style={{ color: "red" }}>*</b>
              <input
                type="number"
                className="form-control websiteLink"
                value={weatherInput}
                onChange={(e) => setweatherInput(e.target.value)}
              ></input>
              <div className="row" style={{ marginBottom: "10px" }}>
                <div className="col-6" style={{ paddingRight: "4px" }}>
                  <b>Select the unit for Wind Speed</b>
                  <select
                    className="form-control"
                    value={weatherWind}
                    name="Wind speed"
                    onChange={(event) => setweatherWind(event.target.value)}
                  >
                    <option value="km">Km per hour</option>
                    <option value="mi">Miles per hour</option>
                  </select>
                </div>
                <div className="col-6" style={{ paddingLeft: "4px" }}>
                  <b>Select the unit for Temperature</b>
                  <select
                    className="form-control"
                    value={weatherTemp}
                    name="Wind speed"
                    onChange={(event) => setweatherTemp(event.target.value)}
                  >
                    <option value="C">Celsius</option>
                    <option value="F">Fahrenheit</option>
                  </select>
                </div>
              </div>
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={handleSubmit}
              >
                Save
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalyoutubevideo} toggle={toggleyoutubewidget}>
        <ModalHeader toggle={toggleyoutubewidget}>
          Create a new YouTube Video Widget
        </ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit} className="slidesharemainform">
              <b>Enter the url of youtube video</b>
              <b style={{ color: "red" }}>*</b>
              <input
                type="url"
                className="form-control websiteLink"
                value={youtubeVideo}
                onChange={(e) => setyoutubevideo(e.target.value)}
              ></input>
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={handleSubmit}
              >
                Create
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalvideoPlayer} toggle={toggleVideoPlayer}>
        <ModalHeader toggle={toggleVideoPlayer}>
          Create a new DASH/HLS Video Player Widget
        </ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit} className="slidesharemainform">
              <b>Enter the url of video</b>
              <b style={{ color: "red" }}>*</b>
              <input
                type="url"
                className="form-control websiteLink"
                value={videoPlayer}
                onChange={(e) => setvideoPlayer(e.target.value)}
              ></input>
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={handleSubmit}
              >
                Create
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>
      {/*<Modal isOpen={modalOneDrive} toggle={toggleOneDrive}>
        <ModalHeader toggle={toggleOneDrive}>OneDrive Picker</ModalHeader>
        <ModalBody>
          <div>
          </div>
        </ModalBody>
          </Modal>*/}
      <Modal isOpen={modalannouncement} toggle={toggleannouncement}>
        <ModalHeader toggle={toggleannouncement}>
          Create a new Announcement WIdget
        </ModalHeader>
        <ModalBody>
          <div>
            <form onSubmit={onSubmit} className="slidesharemainform">
              <b>Enter the Announcement Message</b>
              <b style={{ color: "red" }}>*</b>
              <textarea
                type="test"
                className="form-control websiteLink"
                value={announcementtext}
                onChange={(e) => setannouncementtext(e.target.value)}
              ></textarea>
              <Button
                color="primary"
                type="submit"
                className="form-control"
                onClick={handleSubmit}
              >
                Create
              </Button>{" "}
            </form>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        size="sm"
        centered={true}
        isOpen={props.modaleditLayoutConfirm}
        toggle={props.toggleEditConfirm}
      >
        <ModalHeader toggle={props.toggleEditConfirm}>Confirmation</ModalHeader>
        <ModalBody>
          <div>
            <div>Dont't forget to save the changes, if not done. </div>
            <div style={{ marginBottom: "20px" }}>
              {" "}
              <b> Are you Sure you want to leave? </b>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                color="success"
                style={{ marginRight: "10px" }}
                onClick={() => {
                  saveLayout();
                  props.toggleEditConfirm();
                  props.setmodaleditLayout(!props.modaleditLayout);
                }}
              >
                Save
              </Button>
              <Button
                color="danger"
                style={{ marginRight: "10px" }}
                onClick={async () => {
                  props.toggleEditConfirm();
                  for (let i = 0; i < props.addwidgetDelete.length; i++) {
                    let dataDelete = {
                      id: props.addwidgetDelete[i],
                    };
                    await httpService
                      .CreateUpdate("removewidgetApi", dataDelete)
                      .catch((err) => {
                        return;
                      });
                  }
                  props.setaddwidgetDelete([]);
                  props.setmodaleditLayout(!props.modaleditLayout);
                }}
              >
                Leave
              </Button>
              <Button
                color="secondary"
                onClick={() => {
                  props.toggleEditConfirm();
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal >
      <NasPop showPicker={showPicker} files={files} selectedFiles={selectedFiles} handleSelectFile={handleSelectFile} handleNASSubmit={handleNASSubmit} setShowPicker={setShowPicker} />


      {/* {showPicker && (
        // newFunction(files, selectedFiles, handleSelectFile, handleNASSubmit, setShowPicker)
      )} */}

      {/* Simple styling for the popup */}
      <style jsx>{`
        .file-picker {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .popup {
          background-color: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </div>
  );
};

export default Layout;
